// NOTE(steckel): I'd prefer this to live in the same file of the Component,
// however, when that happens and it is required by an ember-engine, the layout
// import is also attempted to be resolved which cannot happen because it is
// not also exported. While the ES6 module system is compatible with Ember,
// Ember uses additional logic to resolve the dependencies between (little c)
// components.
//
export let NavigationIcon = /*#__PURE__*/function (NavigationIcon) {
  NavigationIcon[NavigationIcon["X"] = 0] = "X";
  NavigationIcon[NavigationIcon["LeftArrow"] = 1] = "LeftArrow";
  return NavigationIcon;
}({});